/**
 * PATH: src/pages/pricing/PaymentSuccess.jsx
 * PURPOSE: Display success state after successful Razorpay payment
 * UI: Material UI
 */

import React, { useEffect } from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
  const alreadyTracked = sessionStorage.getItem("payment_success_tracked");

  if (!alreadyTracked && window.gtag) {
    window.gtag('event', 'payment_success', {
      source: 'razorpay',
    });

    sessionStorage.setItem("payment_success_tracked", "true");
  }
}, []);

  return (
    <Box p={4} maxWidth="600px" mx="auto">
      <Card elevation={4} sx={{ borderRadius: 3, textAlign: "center", py: 4 }}>
        <CardContent>
          <Typography variant="h4" fontWeight={700} color="success.main">
            Payment Successful
          </Typography>

          <Typography variant="body1" mt={2} mb={4}>
            Thank you! Your subscription is now active.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            sx={{ borderRadius: 2 }}
            onClick={() => navigate("/billing/dashboard")}
          >
            Go to Billing Dashboard
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
